<template>
  <div>
    <b-modal
      id="modal-input-jadwal"
      size="xl"
      centered
      scrollable 
      title="Input Jadwal"
      header-bg-variant="primary"
      header-text-variant="light"
      @show="showModal()"
      @hide="hideModal()"
    >
      <b-row v-if="data">
        <b-col md="6" lg="6" xl="6">
          <div class="mb-3" v-if="!data.dataKaryawanId">
            <Multiselect
              v-model="filter.karyawan"
              :options="listKaryawan"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              label="nama"
              track-by="dataKaryawanId"
              placeholder="-- Pilih Karyawan --"
              size="lg"
            ></Multiselect>
          </div>
          <b-card v-else>
            <div class="">
              <h6 class="m-0 p-0 mb-1 text-success">{{data.namaPosisi}}</h6>
              <h4 class="m-0 p-0">{{data.namaKaryawan}}</h4>
            </div>
          </b-card>
          <b-card class="mb-3" v-if="listJadwalKaryawanTanggal[tanggal]">
            <div v-if="listJadwalKaryawanTanggal[tanggal].masterShiftId">
              <h5 class="d-inline-block mb-2 pb-1 border-bottom" style="">{{$moment(tanggal).format('dddd, DD MMMM YYYY')}}</h5>
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <div class="">
                    <h6 class="m-0 p-0 mb-1">{{listJadwalKaryawanTanggal[tanggal].namaCabang}}</h6>
                    <h4 class="m-0 p-0">{{listJadwalKaryawanTanggal[tanggal].kategoriShift}} - <span class="text-success">{{listJadwalKaryawanTanggal[tanggal].namaShift}}</span></h4>
                  </div>
                </div>
                <div class="py-auto d-flex">
                  <div class="mr-4" style="white-space: nowrap;">
                    <h5 class="m-0 p-0 mb-1" style="">{{listJadwalKaryawanTanggal[tanggal].namaJamKerja}}</h5>
                    <p class="m-0 p-0 text-right">{{listJadwalKaryawanTanggal[tanggal].namaNominalUpah}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <h5 class="d-inline-block mb-2 pb-1 border-bottom" style="">{{$moment(tanggal).format('dddd, DD MMMM YYYY')}}</h5>
              <h5 class="m-0 p-0">Day Off</h5>
            </div>
          </b-card>
        </b-col>
        <b-col md="6" lg="6" xl="6" class="d-flex flex-column my-auto w-100">
          <div class="mx-1 mt-1 mb-3">
            <template>
              <b-calendar 
                size="sm"
                block locale="id-ID" 
                @context="pilihTanggal" 
                :date-info-fn="dateClass"
                selected-variant="secondary"
                today-variant="info"
                nav-button-variant="primary"
                start-weekday="1"
              ></b-calendar>
            </template>
          </div>
        </b-col>
        <b-col md="12" lg="12" xl="12">
          <hr class="mt-2 mb-4">
        </b-col>
        <b-col cols="12" class="text-center"><h4>Shift</h4></b-col>
        <b-col cols="12" class="mb-4 mt-3">
          <b-row>
            <b-col md="6" lg="6" xl="6" sm="12">
              <Multiselect
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                label="namaCabang"
                track-by="cabangId"
                placeholder="-- Pilih Cabang --"
                size="lg"
              ></Multiselect>
            </b-col>
            <b-col md="6" lg="6" xl="6" sm="12">
              <b-form-input
                id="filter-tanggal"
                class="mb-2"
                :value="tanggal ? $moment(tanggal).format('dddd, DD MMMM YYYY') : null"
                type="text"
                placeholder="tanggal"
                disabled
                size="lg"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-row class="overflow-auto mx-1" style="max-height: 40vh">
            <b-col cols="12" class="px-1 " v-for="(data, key) in listShift" :key="key">
              <b-card class="mb-3">
                <div class="d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="">
                      <h6 v-if="data.masterShiftId" class="m-0 p-0 mb-1">{{data.namaCabang}}</h6>
                      <h4 class="m-0 p-0">
                        <span v-if="data.masterShiftId">{{data.kategoriShift}} - </span>
                        <span class="text-success">{{data.namaShift}}</span>
                      </h4>
                    </div>
                  </div>
                  <div class="py-auto d-flex">
                    <div v-if="data.masterShiftId" class="mr-4" style="white-space: nowrap;">
                      <h5 class="m-0 p-0 mb-1" style="">{{data.namaJamKerja}}</h5>
                      <p class="m-0 p-0 text-right">{{data.namaNominalUpah}}</p>
                    </div>
                    <b-button 
                      class="px-4 rounded-pill d-flex flex-column justify-content-center" 
                      :style="`background-color: ${data.warna};`" 
                      @click="tambahShift(data)"
                      :disabled="disablePilih || listJadwalKaryawanTanggal[tanggal] != null"
                    ><CIcon name="cil-check" /></b-button>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row> 
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-row class="overflow-auto mx-1" style="max-height: 40vh">
            <b-col cols="12" class="px-1" v-for="(data, key) in listInputShift" :key="key">
              <b-card class="mb-3">
                <h5 class="d-inline-block mb-2 pb-1 border-bottom" style="">{{data.namaTanggal}}</h5>
                <div class="d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="">
                      <h6 v-if="data.masterShiftId" class="m-0 p-0 mb-1">{{data.namaCabang}}</h6>
                      <h4 class="m-0 p-0">
                        <span v-if="data.masterShiftId">{{data.kategoriShift}} - </span>
                        <span class="text-success">{{data.namaShift}}</span>
                      </h4>
                    </div>
                  </div>
                  <div class="py-auto d-flex">
                    <div v-if="data.masterShiftId" class="mr-4" style="white-space: nowrap;">
                      <h5 class="m-0 p-0 mb-1" style="">{{data.namaJamKerja}}</h5>
                      <p class="m-0 p-0 text-right">{{data.namaNominalUpah}}</p>
                    </div>
                    <b-button 
                      class="px-4 rounded-pill d-flex flex-column justify-content-center" 
                      :style="`background-color: ${data.warna};`" 
                      @click="listInputShift.splice(key, 1)"
                    ><CIcon name="cil-trash" /></b-button>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row> 
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.show('modal-pilih-data-input')">
          Simpan
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input-jadwal')">
          Tutup
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-pilih-data-input"
      size="md"
      centered
      title="Perhatian .... !!!"
      header-bg-variant="success"
      header-text-variant="light"
    >
      <p>Apakah anda yakin menambahkan shift ini?</p>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-pilih-data-input')">
          Batal
        </b-button>
        <b-button variant="primary" :disabled="busy" @click="simpan()">
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: "modalInputMasterJadwal",
  props: [ 'data', 'listCabang' ], 
  data() {
    return {
      tanggal: null,
      busy: false,
      listKaryawan: [],
      listShift: [],
      listInputShift: [],
      listJadwalKaryawan: [],
      listJadwalKaryawanTanggal: {},
      filter: { 
        cabang: null, 
        karyawan: null,
      },
    };
  },
  computed: {
    disablePilih(){
      for (let i = 0; i < this.listInputShift.length; i++) {
        const x = this.listInputShift[i];
        // console.log(this.listInputShift)
        // console.log(x.tanggalAbsen, ' - ', this.moment(this.tanggal).format('YYYY-MM-DD'))
        if(x.tanggalAbsen == this.$moment(this.tanggal).format('YYYY-MM-DD')){
          return true
        }
      }
      return false
    }
  },
  watch: {
    'filter.cabang'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getShift();
      }
    },
    'filter.karyawan'(newVal, oldVal) {
      if (newVal != oldVal) {
        if(newVal){
          // this.filter.cabang = {namaCabang: newVal.namaCabang, cabangId: newVal.cabangId}
          this.getData();
        }
      }
    },
  },
  async mounted() {
    await this.getKaryawan()
  },
  methods: {
    dateClass(date) {
      const vm = this
      const res = vm.listJadwalKaryawan.findIndex((x)=>{
        return vm.$moment(x.tanggalAbsen).format('YYYY-MM-DD') == vm.$moment(date).format('YYYY-MM-DD')
      })
      if(res != -1){
        vm.listJadwalKaryawanTanggal[vm.$moment(date).format('YYYY-MM-DD')] = vm.listJadwalKaryawan[res]
        return 'table-secondary'
      }else{
        return ''
      }
    },
    pilihTanggal(e) {
      const vm = this
      vm.tanggal = vm.$moment(e.selectedDate).format('YYYY-MM-DD')
    },
    async showModal(){
      const vm = this
      await new Promise(resolve => setTimeout(resolve, 100));
      // console.log('data', vm.data)
      if(vm.data.dataKaryawanId) {
        vm.filter.karyawan = {nama: `${vm.data.namaKaryawan} - ${vm.data.namaPosisi}`, dataKaryawanId: vm.data.dataKaryawanId}
        vm.filter.cabang = {namaCabang: vm.data.namaCabang, cabangId: vm.data.cabangId}
        vm.getData()
      }
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      vm.tanggal = this.$moment().format('YYYY-MM-DD')
    },
    hideModal(){
      const vm = this
      vm.$emit("changeVar", {name: 'data', data: {}})
      vm.listInputShift = []
      vm.listJadwalKaryawan = []
      vm.listJadwalKaryawanTanggal = {}
      vm.filter = { 
        cabang: null, 
        karyawan: null,
      }
    },  
    async getData(){
      const vm = this
      const jadwalKaryawan = await vm.$axios.post('/masterShift/listJadwalShift', {
        dataKaryawanId: vm.filter.karyawan ? vm.filter.karyawan.dataKaryawanId : null,
      }) 
      // console.log('jadwalKaryawan', jadwalKaryawan)
      vm.listJadwalKaryawan = jadwalKaryawan.data.status == 200 && jadwalKaryawan.data.data.length ? jadwalKaryawan.data.data[0].jadwalShift.map(x =>{
        return {
          ...x,
          namaJamKerja: vm.$moment(x.jamMasuk, 'HH:mm:ss').format('HH:mm') + ' - ' + vm.$moment(x.jamKeluar, 'HH:mm:ss').format('HH:mm'),
          namaNominalUpah: vm.toNumeric(x.nominalUpah, 'idr'),
          namaTanggalAbsen: vm.$moment(x.tanggalAbsen).format('DD-MM-YYYY')
      }}) : []
      vm.getShift()
    },
    async getKaryawan(){
      const vm = this
      const listKaryawan = await vm.$axios.post('dataKaryawan/list', {
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
      })
      console.log('listKaryawan', listKaryawan)
      if (listKaryawan.data.status == 200) {
        vm.listKaryawan = listKaryawan.data.data.map((x)=>{
          return{
            ...x,
            nama: `${x.namaKaryawan} - ${x.namaPosisi}`,
          }
        })
      }
    },
    async getShift(){
      const vm = this
      const listShift = await vm.$axios.post('/masterShift/list', {cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,})
      // console.log('listShift', listShift)
      if (listShift.data.status == 200) {
        listShift.data.data.push({
          masterShiftId: null,
          namaCabang: '',
          namaShift: 'Day Off',
          namaJamKerja: '',
          namaNominalUpah: '',
          warna: '#CED2D8'
        })
        vm.listShift = listShift.data.data.map((x)=>{
          return{
            ...x,
            namaJamKerja: vm.$moment(x.jamMasuk, 'HH:mm:ss').format('HH:mm') + ' - ' + vm.$moment(x.jamKeluar, 'HH:mm:ss').format('HH:mm'),
            namaNominalUpah: vm.toNumeric(x.nominalUpah, 'no-idr'),
          }
        })
      }
    },
    tambahShift(data){
      const vm = this
      vm.listInputShift.push({
        // kirim database
        namaTanggal: vm.$moment(vm.tanggal).format('dddd, DD MMMM YYYY'),
        tanggalAbsen: vm.$moment(vm.tanggal).format('YYYY-MM-DD'),
        hariAbsen: vm.$moment(vm.tanggal).format('dddd'),
        masterShiftId: data.masterShiftId,
        cabangId: data.cabangId,
        // tampilan
        namaCabang: data.namaCabang,
        kategoriShift: data.kategoriShift,
        namaShift: data.namaShift,
        namaJamKerja: data.namaJamKerja,
        namaNominalUpah: data.namaNominalUpah,
        warna: data.warna,
      })
      // console.log('vm.listInputShift', vm.listInputShift)
    },
    async simpan(){
      const vm = this
      const simpan = await vm.$axios.post('/masterShift/createJadwal', {
        dataKaryawanId: vm.filter.karyawan.dataKaryawanId,
        bulkJadwal: vm.listInputShift
      })
      // console.log('simpan', simpan)
      vm.$bvModal.hide("modal-pilih-data-input");
      if(simpan.data.status == 200){
        vm.reset()
        vm.$bvModal.hide("modal-input-jadwal");
        vm.$emit("triggerAlert", {
          variant: "success",
          msg: "BERHASIL MENGUBAH JADWAL",
          show: true,
        });
      }else{
        vm.$emit("triggerAlert", {
          variant: "danger",
          msg: "GAGAL MENGUBAH JADWAL",
          show: true,
        });
      }
    },
    reset(){
      const vm = this
      vm.listInputShift = []
    },
    toNumeric(number, type){
      let data = {}
      if(type == 'no-idr') {
        return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(number).slice(3)
      }else{
        if(type == 'idr') data = {style: 'currency', currency: 'IDR'}
        return new Intl.NumberFormat('id-ID', data).format(number)
      }
    },
  },
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  margin: 0px;
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #02a433;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>